export type LoadStatus = 'new' | 'load' | 'success' | 'error';

export const languageList = ['EN', 'RU', 'ES'] as const;

export type Language = typeof languageList[number];
